import { render, staticRenderFns } from "./website-setting.vue?vue&type=template&id=6140e496&scoped=true"
import script from "./website-setting.vue?vue&type=script&lang=js"
export * from "./website-setting.vue?vue&type=script&lang=js"
import style0 from "./website-setting.vue?vue&type=style&index=0&id=6140e496&prod&scoped=true&lang=scss"
import style1 from "./website-setting.vue?vue&type=style&index=1&id=6140e496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140e496",
  null
  
)

export default component.exports